export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '活动奖励兑换记录';